import { Office } from "@/models/office";

export const uuidv4 = () => {
  const chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
  for (let i = 0, len = chars.length; i < len; i++) {
    switch (chars[i]) {
      case "x":
        chars[i] = Math.floor(Math.random() * 16).toString(16);
        break;
      case "y":
        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
        break;
    }
  }
  return chars.join("");
};

export const formatKwh = (n: number): string => {
  if (isNaN(Number(n))) return "";
  let s = Number(n.toFixed(1)).toLocaleString();
  if (!s.includes(".")) {
    s += ".0";
  }
  return s;
};

/**
 * ある1文字が全角かどうか判定する
 * @param char 長さ1の文字列
 * @returns 渡された1文字が全角かどうか
 */
export const checkIf2ByteChar = (char: string) => {
  // eslint-disable-next-line no-control-regex
  return /^[^\x01-\x7E\uFF61-\uFF9F]{1}$/.test(char);
};

/**
 * 文字列がSJISでエンコードされていると仮定して、バイト数を取得する
 * @param str バイト数を取得する文字列
 * @returns SJISでの文字列のバイト数
 */
export const countStrByte = (str: string): number => {
  if (str.length === 0) {
    return 0;
  }

  return str
    .split("")
    .map((s) => (checkIf2ByteChar(s) ? 2 : 1))
    .reduce((pre, cur) => pre + cur, 0);
};

const DOWNLOAD_URL_REGXP = /.+\/(.+?)([?#;].*)?$/;

// ダウンロードURLからファイルをダウンロードする
export const downloadFromURL = (url: string): string | undefined => {
  const matches = url.match(DOWNLOAD_URL_REGXP);
  if (matches == null || matches.length < 2) {
    return `このURLにはファイル名が含まれていません。: ${url}.`;
  }

  const fileName = matches[1];
  const link = document.createElement("a");
  link.download = fileName;
  link.href = url;

  link.click();
};

export const getOfficeOptionLabel = (opt?: Office) =>
  opt ? `${opt.displayName}(${opt.id})` : "";

// CSVダウンロード実行関数
export const downloadCsv = (csvContent: string, fileName: string): void => {
  // BOMを追加してExcelで正しく表示されるようにする
  const bom = "\uFEFF";
  const blob = new Blob([bom + csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  // ダウンロード実行
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
